<template>
    <div class="input-group">
        <span class="input-group-addon" @click="open"><i class="icon icon-passenger" /></span>
        <bottom-up-modal :show.sync="showModal" v-if="!$device.desktop">
            <header class="p-2 relative">
                <h5 class="my-1">
                    مسافران
                </h5>
            </header>
            <div class="p-2">
                <div v-if="headerText" class="text-danger small w-500 mb-3">
                    {{ headerText }}
                </div>
                <div v-else class="py-1" />

                <div class="px-1 mb-2 clearfix" v-for="item in passengerItems" :key="item.value" ref="items">
                    <span class="inline-block">
                        <strong class="w-500" data-test="passengerPickerTitle">{{ item.title }}</strong>
                        <small class="mx-2">{{ item.subtitle }}</small>
                    </span>

                    <div class="pull-left">
                        <span
                            class="inline-block style-btn-increase"
                            @click="increase(item.value, 1)"
                            data-test="passengerPickerValueIncrease"
                        />
                        <span
                            class="inline-block mx-1 text-center"
                            data-test="passengerPickerValue"
                            style="min-width: 12px;"
                        >
                            {{ value[item.value] }}
                        </span>
                        <span
                            class="inline-block style-btn-decrease"
                            @click="increase(item.value, -1)"
                            data-test="passengerPickerValueDecrease"
                        />
                    </div>
                </div>
            </div>
            <div v-if="types" class="p-2 pt-0 lh-lg">
                <hr class="mt-0 mb-3">
                <div v-for="item in types" :key="item.value" class="mb-1">
                    <!--Item-->
                    <input type="radio" name="classType" v-model="selectedType" :id="'passenger_class_' + item.value" class="radifier" :value="item.value">
                    <label class="radifier-label" :for="'passenger_class_' + item.value">{{ item.text }}</label>
                </div>
            </div><!--Type Class Flight-->
            <footer class="p-2">
                <button class="btn btn-block btn-primary" @click.prevent="handleSubmit" ref="submitButton">
                    تائید
                </button>
            </footer>
        </bottom-up-modal>
        <div class="v-dropdown full" ref="dropdown" v-else>
            <div class="p-2">
                <div v-if="headerText" class="text-danger small w-500 mb-3">
                    {{ headerText }}
                </div>
                <div v-else class="py-1" />

                <div class="px-1 mb-2 clearfix not-selectable" v-for="item in passengerItems" :key="item.value" ref="items">
                    <span class="inline-block">
                        <strong class="w-500" data-test="passengerPickerTitle">{{ item.title }}</strong>
                        <small class="mx-2">{{ item.subtitle }}</small>
                    </span>

                    <div class="pull-left">
                        <span
                            class="inline-block style-btn-increase"
                            @click="increase(item.value, 1)"
                            data-test="passengerPickerValueIncrease"
                        />
                        <span
                            class="inline-block mx-1 text-center"
                            data-test="passengerPickerValue"
                            style="min-width: 12px;"
                        >
                            {{ value[item.value] }}
                        </span>
                        <span
                            class="inline-block style-btn-decrease"
                            @click="increase(item.value, -1)"
                            data-test="passengerPickerValueDecrease"
                        />
                    </div>
                </div>
            </div>
            <div v-if="types" class="p-2 pt-0 lh-lg">
                <hr class="mt-0 mb-3">
                <div v-for="item in types" :key="item.value" class="mb-1">
                    <!--Item-->
                    <input type="radio" name="classType" v-model="selectedType" :id="'passenger_class_' + item.value" class="radifier" :value="item.value">
                    <label class="radifier-label" :for="'passenger_class_' + item.value">{{ item.text }}</label>
                </div>
            </div><!--Type Class Flight-->
        </div>
        <input
            ref="input"
            type="text"
            name="passengers"
            class="form-control"
            placeholder="مسافران"
            :tabindex="tabindex"
            readonly
            :value="passengersText"
            v-dropdown.fade.focus="() => $refs.dropdown"
            @click="showModal = !$device.desktop"
            aria-describedby="search-passengers"
            data-test="passengerPicker"
        >
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import BottomUpModal from '~/components/common/modal/bottom-up-modal';

export default {
    components: {
        BottomUpModal,
    },
    props: {
        value: {
            type: Object,
            default: () => ({
                adult: 1,
                child: 0,
                infant: 0,
            }),
        },
        maxPassengers: {
            type: Number,
            default: 0,
        },

        tabindex: {
            type: Number,
            default: null,
        },

        types: {
            type: Array,
            default: null,
        },

        type: {
            type: String,
            default: null,
        },
    },
    data () {
        return {
            showModal: false,
        };
    },
    computed: {
        passengerItems () {
            return [
                { value: 'adult', title: 'بزرگسال', subtitle: '(۱۲ سال به بالا)' },
                { value: 'child', title: 'کودک', subtitle: '(۲ سال تا ۱۲ سال)' },
                { value: 'infant', title: 'نوزاد', subtitle: '(۱۰ روز تا ۲ سال)' },
            ];
        },
        totalPassengers () {
            const { adult, child, infant } = this.value;
            return adult + child + infant;
        },

        passengersText () {
            const { adult, child, infant } = this.value;
            return `${adult + child + infant} مسافر`;
        },

        headerText () {
            return null;
        },

        selectedType: {
            get () {
                return this.type;
            },
            set (x) {
                this.$emit('update:type', x);
            },
        },
    },
    methods: {
        ...mapActions(['openAlert']),

        validate ({ adult, child, infant }) {
            if (adult < 1) {
                return 'تعداد بزرگسالان نمی‌تواند کمتر از ۱ باشد.';
            }
            if (adult + child + infant > this.maxPassengers) {
                return `حداکثر تعداد مسافران ${this.maxPassengers} نفر است.`;
            }
            if (infant < 0 || child < 0) {
                return true;
            }
            return null;
        },

        increase (type, count) {
            const newValue = Object.assign({}, this.value, { [type]: this.value[type] + count });
            const message = this.validate(newValue);
            if (message) {
                typeof message === 'string' && this.openAlert(message);
                return;
            }
            this.$emit('input', newValue);
        },

        open () {
            if (this.$device.desktop) {
                setTimeout(() => this.$refs.input.focus(), 5);
            } else {
                this.showModal = true;
            }
        },

        handleSubmit () {
            this.showModal = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~vars';

.radifier-label {
    color: $black !important;
}

.close {
    opacity: 1;
    color: $orange;
    font-size: 30px;
}

.v-dropdown {
    min-width: 320px;
    margin-top: 5px;

    @media (min-width: 992px) {
        right: auto;
        left: 0;
    }

    &::before {
        content: '';
        display: block;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-bottom-color: $snow-white;
        position: absolute;
        top: -10px;
        left: 10px;
        @media (min-width: 1200px) {
            right: 145px;
            left: auto;
        }
        z-index: 21;
    }

    &.up {
        margin-top: 0;
        margin-bottom: 5px;

        &::before {
            top: auto;
            bottom: -10px;
            border-top-color: $snow-white;
            border-bottom-color: transparent;
        }
    }
}
</style>
